module.exports = __webpack_public_path__ + "img/ruanbao4.5941e560.jpg";